import { useFetchPaymentIntent } from './useFetchPaymentIntent'

const create = () => {
  const { create: mutationFn } = useFetchPaymentIntent()

  return useMutation({
    mutationFn,
  })
}

const confirm = () => {
  const { confirm: mutationFn } = useFetchPaymentIntent()

  return useMutation({
    mutationFn,
  })
}

export const useMutationPaymentIntent = {
  create,
  confirm,
}
